module.exports = __webpack_public_path__ + "static/coworker3-16dd7bdae833db8f3aec58bd75b21d98.png";